import { JudicialActionFlag } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import { SelectOption } from '@indigo-ag/component-module';

import { text as textUtils } from '../utils/text.util';

export const judicialFlagsTranslations: { [key in JudicialActionFlag]: string } = {
  [JudicialActionFlag.RED]: i18next.t('red'),
  [JudicialActionFlag.GREEN]: i18next.t('green'),
  [JudicialActionFlag.YELLOW]: i18next.t('yellow')
};

export const flagTypeOptions: SelectOption<JudicialActionFlag>[] = Object.keys(JudicialActionFlag).map(flagType => ({
  name: textUtils.toTitleCase(judicialFlagsTranslations[flagType]),
  value: flagType as JudicialActionFlag
}));
